import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Typography, Tabs } from "antd";
import { listServiceRequestsApi } from "../../../services/serviceRequests.services";
import { useNavigate } from "react-router-dom";
import useQuery from "../../../hooks/useQuery";
import { updateUrlSearchParams, parsePageParam } from "../../../helpers/urlFilters";
import CustomLayout from "../../Layout/CustomLayout";
import SideMenu from "../../Layout/CustomLayout/SideMenu";
import typoStyles from "../../../styles/Custom/Typography.module.css";
import { UserContext } from "../../../context/UserContext";
import { getCookie } from "../../../helpers/localStorage";
import { Role } from "../../../constants/defaultKeys";
import ServiceRequstTableEdit from "./ServiceRequestsTableEdit";
import { UiDataTable } from "../../ui";

const options = [
  { label: "Pending", key: "PENDING" },
  { label: "Approved", key: "APPROVED" },
  { label: "Rejected", key: "REJECTED" }, 
];

const ServiceRequestsMenu = () => {
  const { userDetails } = useContext(UserContext);
  const [requestsData, setRequestsData] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const params = useQuery();
  const [page, setPage] = useState(() => parsePageParam(params));
  const [searchQuery, setSearchQuery] = useState(null);
  const refreshPage = () => {
    setRefresh((prev) => !prev);
  };

  useEffect(() => {
    let queryParams = {
      page: page,
      limit: 100,
    };
  
    if (params?.status) {
      queryParams.status = params.status;
    }
  
    if (searchQuery) {
      queryParams.search = searchQuery;
      queryParams.page = 1;
    }
  
    const queryString = new URLSearchParams(queryParams);
  
    setLoading(true);
    listServiceRequestsApi(queryString)
      .then((res) => {
        setRequestsData(res?.data);
        setLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  }, [refresh, page, searchQuery, params?.status]);

  const onChange = (value) => {
    setPage(1);
    updateUrlSearchParams(navigate, { status: value, page: null });
  };

  const handlePageChange = (value) => {
    setPage(value);
    updateUrlSearchParams(navigate, { page: value === 1 ? null : value });
  };

  return (
    <CustomLayout
      header={
        <div
        style={{
          gap: "5%",
          width: "100%",
        }}
        className="flex-start"
        >
          <Typography className={typoStyles.h6}>Service Requests</Typography>
          <Tabs
                items={options}
                onChange={onChange}
                defaultActiveKey={params?.status}
                style={{ width: "70%", paddingTop: "16px" }}
                />
        </div>
    }
      
      sideContent={<SideMenu />}
    >
      <UiDataTable
        showHeader={false}
        showSearch={false}
        shellClassName="ui-table-fill-shell"
      >
        <ServiceRequstTableEdit
          data={requestsData}
          setData={setRequestsData}
          refreshPage={refreshPage}
          loading={loading}
          page={page}
          setPage={handlePageChange}
          userDetails={userDetails}
          status={params?.status}
        />
      </UiDataTable>
    </CustomLayout>
  );
};

export default ServiceRequestsMenu;
